import { render, staticRenderFns } from "./CDRQ.vue?vue&type=template&id=24bc7c49&"
import script from "./CDRQ.vue?vue&type=script&lang=ts&"
export * from "./CDRQ.vue?vue&type=script&lang=ts&"
import style0 from "./CDRQ.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports